import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Free consultation",
    body: "A 30-minute chat about your week, your stress points, and the jobs eating your time. No spreadsheets needed.",
    color: "bg-[var(--pink)] text-white",
  },
  {
    n: "02",
    title: "We map the workflow",
    body: "We sketch the AI assistant or automation in plain English, agree the scope and price, and confirm what success looks like.",
    color: "bg-white text-ink",
  },
  {
    n: "03",
    title: "Build & connect",
    body: "Typically 1–3 weeks. We plug into your phone, email, calendar and CRM. You test it. We tweak until it's spot on.",
    color: "bg-[var(--blue)] text-white",
  },
  {
    n: "04",
    title: "Go live & optimise",
    body: "You hit go. We monitor, learn from real conversations, and refine — so it gets smarter every week.",
    color: "bg-[var(--yellow)] text-ink",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="border-b-2 border-ink py-24 lg:py-32 bg-[var(--paper)]"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <p className="uppercase text-sm font-bold tracking-[0.25em] text-[var(--blue)]">
            How it works
          </p>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
            From <span className="text-[var(--pink)]">chaos</span> to{" "}
            <span className="text-[var(--blue)]">calm</span> in four steps.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              data-testid={`how-it-works-step-${i + 1}`}
              className={`border-2 border-ink rounded-3xl p-7 shadow-brutal ${s.color} relative overflow-hidden`}
            >
              <span className="font-display absolute -top-3 -right-2 text-[120px] font-black opacity-10 leading-none select-none">
                {s.n}
              </span>
              <p className="font-display text-5xl font-black">{s.n}</p>
              <h3 className="font-display mt-4 text-2xl font-extrabold">
                {s.title}
              </h3>
              <p
                className={`mt-3 ${s.color.includes("text-white") ? "text-white/90" : "text-stone-700"}`}
              >
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
